import { selectInstitution } from "../selectors";
import { createDeepEqualSelector } from "../utils";

export const selectNAFItems = createDeepEqualSelector(
  [selectInstitution],
  (institution) => {
    const listOfNafItems: {
      [key: string]: API.AppMenuItem;
    } = {};

    institution?.apps?.forEach((app) => {
      listOfNafItems[app.name] = { app };
    });

    return listOfNafItems;
  },
);

export const selectNarmiTiles = createDeepEqualSelector(
  [selectInstitution],
  (institution) => {
    const nafApps = institution?.tiles || [];
    return nafApps;
  },
);
